import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faCheck, faXmark, faWallet, faMoneyBill1 } from "@fortawesome/free-solid-svg-icons";
import "./walletModeCell.scss";

/**
 * Put one driver on the wallet, or take him off it, from the table.
 *
 * TWO MODELS, NAMED. The column is a boolean on the server
 * (`deliveries.wallet_enabled`, api#137) but «المحفظة: نعم» does not say what
 * happens to the driver, so both states carry their own words here and on the
 * driver form: نقدي pays at the end of the month, محفظة is debited on every
 * order he accepts.
 *
 * NOT A ONE-CLICK TOGGLE, deliberately. This decides whether a driver pays for
 * every order he takes, and a wallet driver whose balance is 0 can claim
 * nothing at all — so a mis-click in a dense table would stop somebody working.
 * It opens a picker and waits for ✓, the same shape as the order-ceiling cell
 * beside it.
 */
const WalletModeCell = ({ enabled, onSave, disabled = false }) => {
    const isOnWallet = enabled === true;
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState("false");
    const [saving, setSaving] = useState(false);

    const open = () => {
        setDraft(isOnWallet ? "true" : "false");
        setEditing(true);
    };

    const cancel = () => setEditing(false);

    const save = async () => {
        const next = draft === "true";

        // Nothing to write, and the server would record no audit note either.
        if (next === isOnWallet) {
            setEditing(false);
            return;
        }

        setSaving(true);
        try {
            await onSave(next);
            setEditing(false);
        } finally {
            setSaving(false);
        }
    };

    if (editing) {
        return (
            <td className="wallet-mode-cell">
                <div className="wallet-mode-cell__edit">
                    <select
                        value={draft}
                        disabled={saving}
                        onChange={(event) => setDraft(event.target.value)}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") save();
                            if (event.key === "Escape") cancel();
                        }}
                        aria-label="نظام الدفع"
                    >
                        <option value="false">نقدي</option>
                        <option value="true">محفظة</option>
                    </select>
                    <button type="button" onClick={save} disabled={saving} title="حفظ">
                        <FontAwesomeIcon icon={faCheck} />
                    </button>
                    <button type="button" onClick={cancel} disabled={saving} title="إلغاء">
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
            </td>
        );
    }

    return (
        <td className="wallet-mode-cell">
            <button
                type="button"
                className={`wallet-mode-cell__value wallet-mode-cell__value--${
                    isOnWallet ? "wallet" : "cash"
                }`}
                onClick={open}
                disabled={disabled}
                title={
                    isOnWallet
                        ? "محفظة — يخصم من رصيده مع كل طلب. اضغط للتعديل"
                        : "نقدي — يدفع في آخر الشهر. اضغط للتعديل"
                }
            >
                <FontAwesomeIcon icon={isOnWallet ? faWallet : faMoneyBill1} size="xs" />
                <span>{isOnWallet ? "محفظة" : "نقدي"}</span>
                <FontAwesomeIcon className="wallet-mode-cell__pen" icon={faPen} size="xs" />
            </button>
        </td>
    );
};

export default WalletModeCell;
